export const map = async (err) => {
  if (err) {
    console.error(err);
  }

  let map;

  function fullScreen(map) {
    const mapDiv = document.getElementsByClassName('fullscreen-button');

    const elementToSendFullscreen = map.getDiv().firstChild;

    Array.prototype.forEach.call(mapDiv, function (el) {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        requestFullscreen(elementToSendFullscreen);
      });
    });
  }

  function requestFullscreen(element) {
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.webkitRequestFullScreen) {
      element.webkitRequestFullScreen();
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen();
    } else if (element.msRequestFullScreen) {
      element.msRequestFullScreen();
    }
  }

  async function initMap() {
    const { Map } = await google.maps.importLibrary('maps');
    const { AdvancedMarkerElement } = await google.maps.importLibrary('marker');

    const mapDiv = document.getElementsByClassName('acf-map');
    const markerDiv = document.getElementsByClassName('marker');

    const latLng = {
      lat: Number(markerDiv[0].dataset.lat),
      lng: Number(markerDiv[0].dataset.lng),
    };

    // One map element now serves both layouts, so the mobile zoom level that
    // used to live on the mobile-only copy comes from a data attribute.
    const isMobile = !window.matchMedia('(min-width: 48rem)').matches;

    Array.prototype.forEach.call(mapDiv, function (el) {
      map = new Map(el, {
        center: latLng,
        zoom: Number((isMobile && el.dataset.zoomMobile) || el.dataset.zoom),
        mapId: 'locationMap',
        fullscreenControl: true,
      });
      //const image = "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png";
      fullScreen(map);

      const marker = new AdvancedMarkerElement({
        map,
        position: latLng,
        //icon: image,
      });
    });
  }

  if (document.getElementsByClassName('acf-map').length) {
  initMap();
  }
};

import.meta.webpackHot?.accept(map);